import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

const HeaderPage = ({ title }) => {

  const navigate = useNavigate();

  const handleBackClick = () => {
    if (window.history.length > 2) {
      navigate(-1);  // Goes back in history
    } else {
      navigate('/');  // Navigate to the home page if no history
    }
  };

  return (
    <>

      <header
        className="header header-fixed style-3"
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -60, opacity: 0 }}
        transition={{ duration: 0.35, ease: "easeOut" }}
        style={{
          background: 'linear-gradient(135deg, #1A0E00 0%, #3D2800 40%, #1A0E00 100%)',
          borderBottom: '2px solid #C9963A',
          boxShadow: '0 2px 16px rgba(201,150,58,0.25)'
        }}
      >
        <div className="header-content gap-2">
          <div className="left-content">
            <a
              href="javascript:void(0);"
              onClick={handleBackClick}
              className="back-btn dz-icon icon-sm"
              style={{
                color: '#FFD700',
                background: 'rgba(201,150,58,0.18)',
                borderRadius: '8px',
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(201,150,58,0.4)'
              }}
            >
              <i className="fi fi-rs-angle-left" style={{ color: '#FFD700', fontSize: '16px' }} />
            </a>
          </div>
          <div className="mid-content">

            {title.length !== 0 ?
              <h5
                className="title text-truncate"

              >
                {title}
              </h5>
              :
              <div
                className="card-1 skeleton"
                style={{ borderRadius: 5, height: 40, width: 180 }}
              ></div>
            }

          </div>
          <div className="right-content" />
        </div>
      </header>



    </>
  );
};

export default HeaderPage;
